<template>
  <a-table
    :columns="goodsTable"
    :data-source="goodsList"
    :pagination="false"
    :row-class-name="rowClass"
    bordered
    :scroll="{ x: 'calc(700px + 50%)'}"
    :custom-row="customRow"
    class="goods-table table-multip"
  >
    <template slot="goosInfo" slot-scope="text, rowData">
      <p>共{{rowData.goodsInfo.skuSum}}{{rowData.goodsInfo.skuUnit}}</p>
      <p>共{{rowData.goodsInfo.weightTon}}kg/{{rowData.goodsInfo.volume}}M³</p>
    </template>
    <!-- 出库量 -->
    <template slot="deliver" slot-scope="text, rowData">
      <p>共{{rowData.deliver_finish_sum}}件</p>
    </template>
    <!-- 计划量 -->
    <template slot="plan" slot-scope="text, rowData">
      <p>共{{rowData.planAmount}}件</p>
      <p>共{{rowData.planWeight}}kg/{{rowData.planVolume}}M³</p>
    </template>
    <!-- 签收量 -->
    <template slot="sign" slot-scope="text, rowData">
      <p>共{{rowData.sign_sum}}件</p>
      <p>共{{rowData.sign_weight}}}kg/{{rowData.sign_volume}}M³</p>
    </template>
    <!-- 拒收量 -->
    <template slot="refuse" slot-scope="text, rowData" rowSpan="0">
      <p>共{{rowData.refuse_sum}}件</p>
      <p>共{{rowData.refuse_weight}}}kg/{{rowData.refuse_volume}}M³</p>
    </template>
    <!-- 拒收量 -->
    <template slot="store" slot-scope="text, rowData">
      <p>共{{rowData.store_sum}}件</p>
      <p>共{{rowData.store_weight}}}kg/{{rowData.store_volume}}M³</p>
    </template>
  </a-table>
</template>

<script>
export default {
  name: 'AddressGoods',
  props: {
    goodsTable: {
      type: Array,
      default: () => []
    },
    goodsList: {
      type: Array,
      default: () => []
    },
    index:{
      type:Number,
      default:0
    }
  },
  data() {
    return {}
  },
  methods: {
    rowClass(record) {
      return `rowSpan${record.skuId}${this.index}`;
    },
    customRow() {
      return {
        on: {
          mouseenter: (event) => {
            this.mouseAction(event, 'add');
          },
          mouseleave: (event) => {
            this.mouseAction(event, 'remove');
          },
        }
      };
    },
    mouseAction(event, type) {
      const { classList } = event.target;
      let currentClass = '';
      for (let i = 0; i < classList.length; i+=1) {
        if (/rowSpan+/.test(classList[i])) {
        currentClass = classList[i];
        break;
        }
      }
      const eles = document.getElementsByClassName(currentClass);
      for (let i = 0; i < eles.length; i+=1) {
        eles[i].classList[type]('ant-table-row-hover');
      }
    },
  }
}
</script>